export default {
  title: "Collaborateurs",
  description: "Invitez des personnes pour vous aider dans l'organisation de votre mariage",
  count: "{{count}} collaborateurs",
  invite: "Inviter un collaborateur",
  rolesTitle: "Rôles disponibles",
  roles: {
    admin: "Administrateur",
    editor: "Éditeur",
    viewer: "Lecteur"
  },
  roleDescriptions: {
    admin: "Peut tout modifier et gérer les collaborateurs",
    editor: "Peut modifier les sections sélectionnées",
    viewer: "Peut seulement voir les sections sélectionnées"
  },
  inviteEmail: "Adresse email",
  placeholder: "Entrez l'adresse email de la personne à inviter",
  role: "Rôle",
  accessToSections: "Accès aux sections",
  resourceTypes: {
    tasks: "Tâches",
    guests: "Invités",
    budget: "Budget",
    timeline: "Planning"
  },
  inviteSuccess: "Invitation envoyée avec succès",
  list: "Liste des collaborateurs",
  empty: "Aucun collaborateur pour le moment",
  accessTo: "Accès à",
  lastActive: "Dernière activité",
  remove: "Supprimer le collaborateur",
  modifyAccess: "Modifier l'accès",
  updateRoleError: "Erreur lors de la mise à jour du rôle",
  inviteError: "Erreur lors de l'envoi de l'invitation",
  status: {
    pending: "En attente",
    accepted: "Acceptée",
    refused: "Refusée",
    expired: "Expirée"
  },
  activeLinks: {
    title: "Liens de Partage Actifs",
    description: "Gérez les liens permanents qui permettent un accès simplifié.",
    copy: "Copier",
    revoke: "Révoquer",
    linkCopied: "Lien copié !",
    revokeConfirm: "Êtes-vous sûr de vouloir révoquer ce lien ?",
    revokeSuccess: "Lien révoqué avec succès",
    noActiveLinks: "Aucun lien actif",
    securityInfo: "Ces liens permettent l'accès sans compte. Partagez-les avec précaution."
  }
};
